<template>
  <form @submit.prevent="createNewLicense" class="keygen">
    <p class="keygen__warning" v-if="seatLimitReached">
      <b>You've reached the seat limit for your enterprise plan.</b> Please
      disable any unused license keys (by disabling any <em>Active</em> toggles
      below), or
      <a href="https://hypermatic.com/contact" target="_blank">contact us</a>
      for additional seats.
    </p>

    <div class="keygen__header">
      <h3 class="keygen__heading">Create New License Key</h3>
      <p class="keygen__description">
        <b>{{ totalSeats - activeSeats }}/{{ totalSeats }}</b> Seats Available
      </p>
    </div>

    <label for="emailInput" class="login__label">Email Address </label>

    <input
      id="emailInput"
      name="emailInput"
      class="login__input login__input--email"
      :placeholder="placeholderEmail"
      type="email"
      multiple
      :disabled="submitting"
      v-model="emailAddress"
      required
    />

    <label for="emailInput" class="login__label"
      >(Pro Tip: Use comma seperated emails to add multiple keys at once)</label
    >

    <ul v-if="emailAddress != '' && emailAddresses.length">
      <li v-for="(email, i) in emailAddresses" :key="email + i">
        {{ email }}
      </li>
    </ul>

    <p v-if="validationError" role="alert">{{ validationError }}</p>

    <button
      type="submit"
      :disabled="!emailAddress || seatLimitReached || submitting"
      class="login__button"
    >
      <span v-if="submitting">Creating license keys...</span>
      <span v-else-if="emailAddress != '' && emailAddresses.length"
        >Create New License Keys ({{ emailAddresses.length }})</span
      >
      <span v-else>Create New License Key</span>
    </button>
  </form>
</template>

<script>
export default {
  name: "Keygen",
  props: {
    activeSeats: Number,
    totalSeats: Number,
    domain: String,
    createLicenses: { type: Function, required: true }
  },
  data() {
    return {
      emailAddress: "",
      submitting: false,
      validationError: ""
    };
  },
  methods: {
    async createNewLicense() {
      if (this.submitting || this.seatLimitReached) return;
      const emails = this.emailAddresses;
      this.validationError = "";
      if (emails.length > this.seatsRemaining) {
        this.validationError = `You entered ${emails.length} emails. Available seats: ${this.seatsRemaining}. Please reduce the list or free up seats first.`;
        return;
      }
      this.submitting = true;
      try {
        const completed = await this.createLicenses(emails);
        // Preserve failed and unattempted addresses for correction or retry.
        this.emailAddress = emails.slice(completed).join(", ");
      } catch (error) {
        this.validationError = error.message || "Unable to create the license keys. Please try again.";
      } finally {
        this.submitting = false;
      }
    }
  },
  computed: {
    emailAddresses() {
      const emails = this.emailAddress.split(",").map(email => email.trim());
      return emails;
    },
    placeholderEmail() {
      return `eg. name@${this.domain}`;
    },
    seatsRemaining() {
      return this.totalSeats - this.activeSeats;
    },
    seatLimitReached() {
      return this.activeSeats >= this.totalSeats;
    }
  }
};
</script>

<style scoped lang="scss">
.keygen__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keygen__heading {
  margin: 0;
}

.keygen__description {
  font-size: 14px;
  text-align: right;
  margin: 0;
}

.keygen__warning {
  padding: 16px;
  border-radius: 4px;
  border: 2px solid orange;
  background: rgba(255, 166, 0, 0.245);
  margin-top: 0;
}
</style>
